import { DCRecord } from "@/@types/lib/dataController";
import { ShowDialogFn } from "@/@types/ui/DialogContext";
import api from "@/lib/api";
import SingleImageViewer from "@/ui/SingleImageViewer";
import { Box, Grid, useTheme } from "@mui/material";
import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

type ImageControlProps = {
  showDialog: ShowDialogFn;
  image: DCRecord;
  customPath?: string;
};
const ImageControl: FC<ImageControlProps> = (props) => {
  const theme = useTheme();

  const { image, showDialog, customPath = "images" } = props;
  const [imageContent, setImageContent] = useState(image);

  const apiInstance = new api();

  const url = `${customPath}/${image.uuid}`;

  const publicStyles = {
    Box: {
      width: 70,
      marginTop: "3px",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: theme.palette.primary.main,
      borderRadius: "10px",
    },
    layerBox: {
      width: 66,
      "&:hover": {
        ".image-container": {
          borderWidth: "2px",
          borderStyle: "solid",
          borderRadius: "10px",
          borderColor: theme.palette.primary.main,
          boxShadow: 4,
          cursor: "pointer",
        },
        a: {
          color: theme.palette.primary.main,
        },
      },
      ".image-container": {
        borderWidth: "2px",
        borderStyle: "solid",
        borderRadius: "10px",
        borderColor: "#AAAAAA",
      },
    },
    layerBoxSelected: {
      width: 66,
      "&:hover": {
        ".image-container": {
          borderWidth: "2px",
          borderStyle: "solid",
          borderRadius: "10px",
          borderColor: theme.palette.primary.main,
          boxShadow: 4,
          cursor: "pointer",
        },
      },

      ".image-container": {
        borderWidth: "2px",
        borderStyle: "solid",
        borderRadius: "10px",
        borderColor: theme.palette.primary.main,
        boxShadow: 2,
      },
      a: {
        color: theme.palette.primary.main,
      },
    },
  };

  const fetchImage = async () => {
    if (image.hasOwnProperty("content") && image.content) {
      setImageContent(image);
    } else {
      const resp = await apiInstance.Call(url, "get");
      //@ts-ignore
      if (resp.data && resp.data.image) {
        //@ts-ignore
        setImageContent({ ...image, content: resp.data.image });
      }
      // resp.arrayBuffer().then(data => {
      //   const imageB64 = arrayBufferToBase64(data);
      //   setImageContent(imageB64)
      // })
    }
  };

  useEffect(() => {
    fetchImage();
  }, []);

  return (
    <Grid
      size={{ xs: 6, xl: 6 }}
      display={"flex"}
      rowGap={"6px"}
      flexDirection={"column"}
      alignItems={"center"}
      textAlign={"center"}
      sx={publicStyles.layerBox}
      onClick={() => {
        if (showDialog) {
          showDialog(
            () => (
              <SingleImageViewer image={imageContent} path={url} level={2} />
            ),
            {},
            2
          );
        }
      }}
    >
      <Box className={"image-container"} sx={{ height: 66, width: 66 }}>
        <img
          src={
            // @ts-ignore
            imageContent.content
              ? // @ts-ignore
                `data:${imageContent.image_type};base64, ${imageContent.content}`
              : ""
          }
          style={{
            width: 62,
            height: 62,
            borderRadius: "10px",
            objectFit: "cover",
          }}
        />
      </Box>
      <a style={{ fontSize: 14, width: 62, wordWrap: "break-word" }}>
        {/* @ts-ignore */}
        {image.image_name}
      </a>
    </Grid>
  );
};

export default ImageControl;
